module.exports = __webpack_public_path__ + "static/img/8.5c7220d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/8.jpg
// module id = X+jp
// module chunks = 1